const formatCurrency = (value) => {
  if (value >= 1000) {
    return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}K`;
  }
  return `${value}`;
};

const TeamPerformanceTable = (props) => {
  return <div>
    <h2 className="text-2xl mb-4">Team Performance Overview</h2>

    <div className="bg-gradient-to-br from-slate-900/70 to-slate-800/70 backdrop-blur-xl border border-slate-700/50 rounded-2xl overflow-hidden">
      <table className="w-full">
        <thead className="bg-black/40">
          <tr>
            <th className="text-left p-4 font-semibold text-sm text-slate-300">Team</th>
            <th className="text-left p-4 font-semibold text-sm text-slate-300">Stores</th>
            <th className="text-left p-4 font-semibold text-sm text-slate-300">Revenue</th>
            <th className="text-left p-4 font-semibold text-sm text-slate-300">COGs</th>
            <th className="text-left p-4 font-semibold text-sm text-slate-300">Profit</th>
          </tr>
        </thead>
        <tbody>
          {props.teamData.map((row, index) => (
            <tr key={index} className="border-t border-slate-700/30">
              <td className="p-4 text-white">{row.account}</td>
              <td className="p-4 text-slate-400">{row.stores}</td>
              <td className="p-4 text-slate-400">{row.revenue ? formatCurrency(row.revenue) : ''}</td>
              <td className="p-4 text-slate-400">{row.cogs ? formatCurrency(row.cogs) : ''}</td>
              <td className="p-4 text-green-400 font-semibold">{row.profit ? formatCurrency(row.profit) : ''}</td>
            </tr>
          ))}
          <tr className="border-t-2 border-slate-600/50 bg-black/20">
            <td className="p-4 font-bold text-white">Totals</td>
            <td className="p-4">{props.totals.stores}</td>
            <td className="p-4 font-bold text-white">{formatCurrency(props.totals.revenue)}</td>
            <td className="p-4 font-bold text-white">{formatCurrency(props.totals.cogs)}</td>
            <td className="p-4 font-bold text-green-400 flex items-center gap-2">
              <span className="text-green-400">▲</span>
              {formatCurrency(props.totals.profit)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}

export default TeamPerformanceTable;
